import { DowntimesStatus, RequestStatusType } from 'shared/enums';
import { Pagination } from 'shared/types/types';
import { edpApiV1 } from '..';

export type TVacationsSupervisorGetRequest = {
  isArchive: boolean;
  page: number;
  size: number;
  divisionId?: string;
  fio?: string;
  byId?: string;
  personnelNumber?: string;
  positionName?: string;
};

export type VacationSupervisor = {
  employee: {
    id: number;
    name: string;
    lastName: string;
    middleName: string;
    image: any;
    division: {
      id: string;
      name: string;
      code: string;
    };
    position: {
      id: string;
      name: string;
    };
  };
  request: {
    id: number;
    type: DowntimesStatus;
    status: {
      name: string;
      type: RequestStatusType;
    };
    comment: string | null;
    endedAt: string;
    isUnpaid: boolean;
    startedAt: string;
    amountDays: number;
    vacationType: {
      id: string;
      name: string;
    };
    rejectionReason: string | null;
  };
  step: {
    depth: number;
    divisionId: string;
    divisionName: string;
    divisionCode: string;
  };
  amountSteps: number;
};

export type VacationSupervisorPaginated = {
  data: VacationSupervisor[];
  pagination: Pagination;
};

export type TVacationSupervisorSingleGetRequest = { requestId: number; divisionId?: string; employeeId?: number };

export interface TSingleVacationGetRequest {
  requestId: number;
  employeeId?: number;
  divisionId?: string;
}

export interface TRejectVacationGetRequest extends TSingleVacationGetRequest {
  rejectionReason;
}
export const vacationApplicationSupervisorApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    vacationsDeputy: build.query<VacationSupervisorPaginated, TVacationsSupervisorGetRequest>({
      query: payload => {
        const { divisionId, ...params } = payload;
        return {
          url: `/v1/dublicate/deputy/vacation-application/requests/${divisionId}`,
          method: 'GET',
          params,
        };
      },
      providesTags: ['vacationDeputy'],
    }),
    singleVacationDeputy: build.query<VacationSupervisor, TVacationSupervisorSingleGetRequest>({
      query: ({ requestId, divisionId }) => {
        return {
          url: `/v1/dublicate/deputy/vacation-application/requests/${divisionId}/${requestId}`,
          method: 'GET',
        };
      },
      providesTags: ['vacationDeputy'],
    }),
    approveVacationDeputy: build.mutation<unknown, TVacationSupervisorSingleGetRequest>({
      query: ({ requestId, divisionId }) => ({
        url: `/v1/dublicate/deputy/vacation-application/requests/${divisionId}/${requestId}/approve`,
        method: 'PATCH',
      }),
      invalidatesTags: ['vacationDeputy'],
    }),
    rejectVacationDeputy: build.mutation<unknown, TRejectVacationGetRequest>({
      query: ({ requestId, divisionId, ...body }) => ({
        url: `/v1/dublicate/deputy/vacation-application/requests/${divisionId}/${requestId}/reject`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['vacationDeputy'],
    }),
    vacationsSupervisor: build.query<VacationSupervisorPaginated, TVacationsSupervisorGetRequest>({
      query: payload => ({
        url: `/v1/dublicate/supervisor/vacation-application/subordinates/requests`,
        method: 'GET',
        params: payload,
      }),
      providesTags: ['vacationSupervisor'],
    }),
    singleVacationSupervisor: build.query<VacationSupervisor, TVacationSupervisorSingleGetRequest>({
      query: ({ requestId }) => ({
        url: `/v1/dublicate/supervisor/vacation-application/subordinates/requests/${requestId}`,
        method: 'GET',
      }),
      providesTags: ['vacationSupervisor'],
    }),
    approveVacationSupervisor: build.mutation<unknown, TVacationSupervisorSingleGetRequest>({
      query: ({ requestId, employeeId }) => ({
        url: `/v1/dublicate/supervisor/vacation-application/subordinates/${employeeId}/requests/${requestId}/approve`,
        method: 'PATCH',
      }),
      invalidatesTags: ['vacationSupervisor'],
    }),
    rejectVacationSupervisor: build.mutation<unknown, TRejectVacationGetRequest>({
      query: ({ requestId, employeeId, ...body }) => ({
        url: `/v1/dublicate/supervisor/vacation-application/subordinates/${employeeId}/requests/${requestId}/reject`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['vacationSupervisor'],
    }),
    vacationsActing: build.query<VacationSupervisorPaginated, TVacationsSupervisorGetRequest>({
      query: ({ divisionId, ...params }) => ({
        url: `/v1/dublicate/acting/${divisionId}/vacation-application/requests`,
        method: 'GET',
        params,
      }),
      providesTags: ['vacationActing'],
    }),
    singleVacationActing: build.query<VacationSupervisor, TVacationSupervisorSingleGetRequest>({
      query: ({ requestId, divisionId }) => ({
        url: `/v1/dublicate/acting/${divisionId}/vacation-application/requests/${requestId}`,
        method: 'GET',
      }),
      providesTags: ['vacationActing'],
    }),
    approveVacationActing: build.mutation<unknown, TVacationSupervisorSingleGetRequest>({
      query: ({ requestId, divisionId }) => ({
        url: `/v1/dublicate/acting/${divisionId}/vacation-application/requests/${requestId}/approve`,
        method: 'PATCH',
      }),
      invalidatesTags: ['vacationActing'],
    }),
    rejectVacationActing: build.mutation<unknown, TRejectVacationGetRequest>({
      query: ({ divisionId, requestId, ...body }) => ({
        url: `/v1/dublicate/acting/${divisionId}/vacation-application/requests/${requestId}/reject`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['vacationActing'],
    }),
  }),
  overrideExisting: false,
});
